import { render, staticRenderFns } from "./pro.vue?vue&type=template&id=52c2cf1c&"
import script from "./pro.vue?vue&type=script&lang=js&"
export * from "./pro.vue?vue&type=script&lang=js&"
import style0 from "./pro.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports